import { BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import CreatePaymentForm from './components/CreatePaymentForm';
import PaymentReview from './components/PaymentReview';
import Header from './components/Header';
import Home from './components/Home';
import LoginForm from './components/LoginForm';
import {useState } from 'react';
import ProtectedRoute from './components/utilities/protectedRoute';
import NotFound from './components/utilities/NotFound';

function App() {
  const [refresh, setRefresh] = useState(false);

  const forceRerender = () => {
    setRefresh((prev) => !prev);
  };

  return (
    <Router>
    <div className="App">
     <Header refresh={refresh} forceRerender={forceRerender}/>
     <Routes>
        {/* Routes are defined here. If the user is authenticated, they can access the home page */}
        <Route path='/' element={ <Home/>}/>
        <Route path='/home' element={<Home/>}/>
        <Route path='/login' element={<LoginForm forceRerender={ forceRerender }/>}/>
        {/* Protect the create payment route */}
        {/* <Route path='/createpayment' element={
          <ProtectedRoute>
            <CreatePaymentForm/>
          </ProtectedRoute>
        } /> */}
        <Route path='/createpayment' element={ <CreatePaymentForm/>}/>
        <Route path='/payment/:type/:encodedUrl' element={ <PaymentReview/>}/>

        {/* Catch-all 404 */}
        <Route path='*' element={<NotFound />} />
     </Routes>
    </div>
    </Router>
  );
}

export default App;
